import { render } from "./SurveyComment.vue?vue&type=template&id=557a57c6&scoped=true"
import script from "./SurveyComment.vue?vue&type=script&lang=js"
export * from "./SurveyComment.vue?vue&type=script&lang=js"

import "./SurveyComment.vue?vue&type=style&index=0&id=557a57c6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557a57c6"]])

export default __exports__